import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import MainLink from "./Link";

const ucp_api = `${MainLink()}api/ucp/`;
const acp_api = `${MainLink()}api/acp/`;
function ACPCheckCharactersRender() {
  const acp_get_applications = acp_api + "get-applications";
  const [applications, setApplications] = useState([]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(acp_get_applications, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("user-id"),
            user_name: localStorage.getItem("user-login"),
            user_password: localStorage.getItem("user-password"),
          }),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setApplications(result || []);
      } catch (err) {
        console.error(err.message);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <SimpleBar className='simple-full-width-container'>
        <div className='ucp-simple-info-block ucp-simple-info-block-acp yellow-shadow width-90 inline-texts main'>
            <span>ИМЯ ПЕРСОНАЖА</span>
            <span>UCP</span>
            <span>СТАТУС</span>
        </div>
        {applications.map((application, index) => {
          const url_check_character = "../../../../acp/check-application?id=" + application.character_id
          return(
          <a href={url_check_character}>
          <div className='ucp-simple-info-block width-90 inline-texts'>
            <span>{application.character_name}</span>
            <span>{application.character_login}</span>
            <span>{(application.character_status).toUpperCase()}</span>
          </div>
          </a>
          )
        })}
        
      </SimpleBar>
      
      
    </div>
  );
}


function ACPCheckApplicationRender() {
  const [loading, setLoading] = useState(true); // Состояние загрузки
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const ucp_get_character = ucp_api + "get-character-info";
  const acp_get_character = acp_api + "get-character-info";
  const ucp_get_situation = ucp_api + "get-role-situation"
  const [characterInfo, setCharacterInfo] = useState([])
  const [situation1, setSituation1] = useState([])
  const [situation2, setSituation2] = useState([])
  const [comment, setComment] = useState("")

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(acp_get_character, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("user-id"),
            user_name: localStorage.getItem("user-login"),
            user_password: localStorage.getItem("user-password"),
            character_id: id,
          }),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        if(result === null){
          return("[ERROR] Не удалось получить информацию о персонаже. Возможно, он не существует.")
        }
        setCharacterInfo(result)
      } catch (err) {
        console.error(err.message);
      } finally{
        setLoading(false)
      }
    };
    
    fetchData()

  }, []);
  useEffect(() => {
    const getSituation1 = async (id) => {
      try {
        const response = await fetch(ucp_get_situation, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("user-id"),
            user_name: localStorage.getItem("user-login"),
            user_password: localStorage.getItem("user-password"),
            situation_id: id,
          }),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setSituation1(result)
      } catch (err) {
        console.error(err.message);
      } 
  };
  const getSituation2 = async (id) => {
      try {
        const response = await fetch(ucp_get_situation, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("user-id"),
            user_name: localStorage.getItem("user-login"),
            user_password: localStorage.getItem("user-password"),
            situation_id: id,
          }),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setSituation2(result)
      } catch (err) {
        console.error(err.message);
      } 
  };
    if (characterInfo && characterInfo.idSituation1 && characterInfo.idSituation2) {
      getSituation1(characterInfo.idSituation1);
      getSituation2(characterInfo.idSituation2);
    }
  }, [characterInfo]);


  const handleSubmitForm = async(event) => {
    event.preventDefault();
    
    const formData = new FormData(event.target); 
    const payload = Object.fromEntries(formData.entries());
    const action = event.nativeEvent.submitter.name;
    try {
      const response = await fetch(acp_api+"change_application_status", {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("user-id"),
            user_name: localStorage.getItem("user-login"),
            user_password: localStorage.getItem("user-password"),
            character_id: payload.character_id,
            admin_comment: payload.admin_comment,
            admin_action: action
          }),
      });
      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status} ${response.headers.Error}`);
      }
      if (response.ok) {
          if (response.headers.get('Content-Length') === '0') {
              throw new Error('Empty response body');
          }
          const data = await response.json();
          window.location.href = "/acp/";
          
      } else {
          const error = await response.json();
          console.error('Ошибка:', error);
          
      }
    } catch (err) {
        console.error('Ошибка соединения:', err);
    }
  }


  var en_gender = ""
  switch(characterInfo["gender"]){
    case 1: en_gender = "human"
    break
    case 2: en_gender = "elf";
    break
    case 4: en_gender = "dwarf";
    break
    case 6: en_gender = "nimf";
    break
  }

  var gender = ""
  switch(characterInfo["gender"]){
    case 1: gender = "ЧЕЛОВЕК"
    break
    case 2: gender = "ЭЛЬФ";
    break
    case 4: gender = "КРАСНОЛЮД";
    break
    case 6: gender = "НИМФА";
    break
  }
  const en_sex = characterInfo["sex"] == 0 ? "male" : "female";
  if(loading) {return("Loading...")}
  if(characterInfo.name === undefined) {return("[ERROR] Не удалось получить информацию о персонаже. Перепроверьте, пожалуйста, актуальность заявки.")}
  return (
    <div>
      <span className="acp-title">ПРОВЕРКА ПЕРСОНАЖА</span>
      <div className='ucp-two-blocks-container ucp-two-blocks-container-acp'>
        <div className='character-body'>
        <img src={"/media/" + en_gender + "_" + en_sex +"_"+characterInfo["selectedSkin"]+".png"}></img>
          <span>{(characterInfo["name"]).split(" ")[0].toUpperCase()}<br />{(characterInfo["name"].split(" ")).length > 1 ? (characterInfo["name"].split(" "))[1].toUpperCase() : ""} <br />{(characterInfo["name"].split(" ")).length > 2 ? (characterInfo["name"].split(" "))[2].toUpperCase() : ""}</span>
        </div>
        <SimpleBar className='ucp-second-container'>
          <h1>ДАТА РЕГИСТРАЦИИ</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{(characterInfo["createDate"].split("T")[0]).split("-")[2] + "." + (characterInfo["createDate"].split("T")[0]).split("-")[1] + "." + (characterInfo["createDate"].split("T")[0]).split("-")[0]}</div>
          <h1>ID ПЕРСОНАЖА</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["id"]}</div>
          <h1>ПОЛ</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["sex"] == 0 ? "МУЖЧИНА" : "ЖЕНЩИНА"}</div>
          <h1>РАСА</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{gender}</div>
          <h1>ИМЯ ПЕРСОНАЖА</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["name"].replace("_", " ").toUpperCase()}</div>
          <h1>КВЕНТА ПЕРСОНАЖА</h1>
          <h1>ПРЕДЫСТОРИЯ</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["prehistory"]}</div>
          <h1>ЧЕРТЫ ХАРАКТЕРА</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["traits"]}</div>
          <h1>НАВЫКИ, УВЛЕЧЕНИЯ</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["skills"]}</div>
          <h1>ВНЕШНИЕ ПРИМЕТЫ</h1>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["appearance"]}</div>

          <h1>РОЛЕВЫЕ СИТУАЦИИ</h1>
          <div className='ucp-simple-info-block'>{situation1["content"]}</div>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["answerSituation1"]}</div>
          <div className='ucp-simple-info-block'>{situation2["content"]}</div>
          <div className='ucp-simple-info-block yellow-shadow'>{characterInfo["answerSituation2"]}</div>
          <form onSubmit={handleSubmitForm}>
          <textarea name="admin_comment" className='ucp-simple-input-text' placeholder='Ответ по заявке...' maxLength={500} value={comment} onChange={e => setComment(e.target.value.replace(/[&%#@*<>]/g, ""))} style={{minHeight:'180px'}}></textarea>
          <input type='hidden' name="character_id" value={characterInfo["id"]}></input>
          <button type='submit' name="accept" className='ucp-simple-yellow-button inline-two-buttons buttons-accept'>ОДОБРИТЬ</button><button type="submit" name="reject" className='ucp-simple-yellow-button inline-two-buttons buttons-accept white-background '>ОТКЛОНИТЬ</button>
          </form>
          </SimpleBar>
        </div>
      </div>
  );
}


export const ACPCheckCharacters = () => ACPCheckCharactersRender()
export const ACPCheckApplication = () => ACPCheckApplicationRender()